module.exports = __webpack_public_path__ + "img/HEART SHADES GREEN.134eac5.svg";